module.exports = __webpack_public_path__ + "static/img/picture_book.0e347c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/picture_book.jpg
// module id = 6+n0
// module chunks = 1